import React, { createContext, useContext, useLayoutEffect } from 'react';
import classnames from 'classnames';

export type Themes = 'default' | 'dark';

export type ThemeProps = {
  theme: Themes;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const ThemeContext = createContext<Themes | undefined>(undefined);

export const Theme = ({
  theme = 'default',
  children,
  className,
  ...props
}: ThemeProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-theme');
  const themeContext = useTheme();

  useLayoutEffect(() => {
    // If themeContext is undefined, it means that we are at the top level Theme component
    // and we want to keep this top level component in sync with the html element
    // so that we have access to the CSS variables outside React root
    if (!themeContext) {
      document.documentElement.dataset.theme = theme;
    }
  }, [themeContext, theme]);

  return (
    <ThemeContext.Provider value={theme}>
      <div className={classNames} data-theme={theme} {...props}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

Theme.displayName = 'Theme';
